var _path, _polyline, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "14 2 14 8 20 8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 8,
    y2: 13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 17,
    x2: 8,
    y2: 17
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 9,
    x2: 8,
    y2: 9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentLined);
export default __webpack_public_path__ + "static/media/DocumentLined.777d1505e86fefae0148add57b59ea25.svg";
export { ForwardRef as ReactComponent };